import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { useChannel, useEvent, usePresenceChannel } from '@harelpls/use-pusher';
import { Modal, ModalBody, Button, Card, CardGroup, ModalFooter, ModalHeader, Row, Col, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import Video from 'twilio-video';
import clsx from 'clsx';
import styled from 'styled-components';

import { createRoom, createToken, createComposition } from 'api/actions/integrations';
import { clientContractAction } from 'api/actions/contracts';
import { fetcher } from 'api/client';
import { CONTROL_MODAL, useSign, useSignDispatch, useSignState, VIDEO_CHAT_MODAL, ZOOM_UPLOAD_VIDEO_MODAL } from 'context/signview';
import { Circle } from './SignView';
import { initialLetters } from 'utils';
import Bootbox from 'components/Modals/Bootbox';
import {toast} from 'components/Shared/Toast';
import DragZone from 'components/Shared/DragZone';
import useFileUpload from 'api/hooks/file/useFileUpload';


export default function ZoomUploadVideo() {
    const [{ modal, contract = {}, jwt }, dispatch] = useSign();
    const [room, setRoom] = useState(null);
    const [file, setFile] = useState(null);
    const [connecting, setPermissions] = useState(false);
    
    const { members } = usePresenceChannel(`presence-video-${contract._id}`);

    const { t } = useTranslation();
    const queryClient = useQueryClient();
     

    const channel = useChannel(contract._id ? `private-${contract._id}` : null);

    const isHost = contract.signViewOptions?.currentParticipant?.isHost;
    const { mutate: mutataUploadZoomMeeting, isLoading } = useMutation((payload) => fetcher(clientContractAction(contract._id, 'uploadZoomMeeting', payload), jwt), {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('client-contract');
            toast.success('El video se subió exitosamente')
            handleClose()
        }
    });
    const { uploadFile, uploadFileState } = useFileUpload({
        onSuccess: (data) => {
            mutataUploadZoomMeeting({ url: data.url })
        }
    });


    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: ZOOM_UPLOAD_VIDEO_MODAL })
        setFile(null)
    }
    const handleUpload = () => {
        uploadFile({
            file
        })
    }
    const changeFile = () => {
        setFile(null)
    }

    const handleFile = async (files) => { 
        for (const file of files) {
            console.log({file})
            setFile(file)
            
        }
    };

    return (
        <Modal isOpen={modal.includes(ZOOM_UPLOAD_VIDEO_MODAL)} centered size={room ? 'fs' : 'md'}
            className={clsx(room && "h-100")}
            contentClassName={clsx(room && "h-100")}
        >
            <div>
            <div className="float-right" onClick={handleClose}>
                <Button color="default" size="sm" style={{ marginRight: '-35px', marginTop: '-40px' }}>
                    <i className="fas fa-times-circle fa-2x light-gray"></i>
                </Button>
            </div>
            <ModalBody className="text-center">

                <h4 className="mt-4"><b>Arrastra el archivo MP4 de la llamada</b></h4>
                { file ? (
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                <i className="fas fa-check text-success"></i>
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            readOnly={true}
                            type="text"
                            placeholder={t('frontDesk.select_file')}
                            value={file?.name}
                        />
                        <Button color="secondary" onClick={changeFile}>
                            <i className="fas fa-upload"></i>
                        </Button>
                    </InputGroup>
                ) : (
                        <DragZone
                            multiple={false}
                            imgSrc="/images/listing/createDocument/subir.svg"
                            label={"Cargar documento"}
                            className="frontdesk-drag bg-indigo-10"
                            acceptedFiles={["video/mp4"]}
                            handleFile={handleFile}
                            onDrop={handleFile}
                        />
                    )
                }
            
                    
            </ModalBody>
            <ModalFooter>
                    <Button
                        block
                        color="primary"
                        className="text-center"
                        onClick={handleUpload}
                        disabled={isLoading || uploadFileState.isLoading || !file}
                    >
                        {(isLoading || uploadFileState.isLoading) ? t('Subiendo...') : t('Subir Video')}
                    </Button>
            </ModalFooter>
        </div>
        </Modal>
    )
}